import { create } from "zustand";

/** Only an error banner can link to a ticket; the other types cannot set `cti`. */
export type NewMessageBanner = { message: string } & (
  | { type: "error"; cti?: boolean }
  | { type: "warning" | "success" | "informational"; cti?: never }
);

export type MessageBanner = NewMessageBanner & { id: string };

interface NotificationStore {
  banners: MessageBanner[];
  addBanner: (banner: NewMessageBanner, autoDismissMs?: number) => string;
  removeBanner: (id: string) => void;
  clearBanners: () => void;
}

export const initialNotificationState: Pick<NotificationStore, "banners"> = { banners: [] };

export const useNotificationStore = create<NotificationStore>((set, get) => ({
  banners: [],
  addBanner: (banner, autoDismissMs) => {
    const id = `banner-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    set((state) => ({
      banners: [...state.banners, { ...banner, id }],
    }));
    if (autoDismissMs) {
      setTimeout(() => get().removeBanner(id), autoDismissMs);
    }
    return id;
  },
  removeBanner: (id) =>
    set((state) => ({ banners: state.banners.filter((b) => b.id !== id) })),
  clearBanners: () => set({ banners: [] }),
}));
